import { Controller } from "stimulus";
import loadScript from "../../assets/load-script";
import translate from "../../assets/translate";

export default class extends Controller {
    static targets = [
        'ccno',
        'cccompany',
        'ccname',
        'ccmm',
        'ccyyyy',
        'ccnoteaser',
        'cardpan',
        'cardtype',
        'cardexpiremonth',
        'cardexpireyear',
        'cardcvc2',
        'errorMessage'
    ];

    static client_api_url = "https://secure.pay1.de/client-api/js/v1/payone_hosted_min.js";
    static cardtypes = {
        'V': 'VisaCard',
        'M': 'MasterCard'
    };

    connect() {
        if (window.Payone === void 0) {
            loadScript(this.constructor.client_api_url)
                .then(() => this.init());
        } else {
            this.init();
        }
    }

    init() {
        this.cardpanTarget.id = this.cardpanTarget.id || "payone-creditcardcheck-cardpan";
        this.cardtypeTarget.id = this.cardtypeTarget.id || "payone-creditcardcheck-cardtype";
        this.cardexpiremonthTarget.id = this.cardexpiremonthTarget.id || "payone-creditcardcheck-cardexpiremonth";
        this.cardexpireyearTarget.id = this.cardexpireyearTarget.id || "payone-creditcardcheck-cardexpireyear";
        this.cardcvc2Target.id = this.cardcvc2Target.id || "payone-creditcardcheck-cardcvc2";
        this.errorMessageTarget.id = this.errorMessageTarget.id || "payone-creditcardcheck-errorMessage";
        this.form = this.ccnoTarget.form;
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.submit_button_text = this.submitButton.innerHTML;

        const request = JSON.parse(this.data.get("request"));
        const config = this.config;
        this.callback_name = "payone_callback_" + Math.round((1 + Math.random()) * 10000000);
        window[this.callback_name] = this.checkCallback.bind(this);
        this.form.addEventListener('submit', this.check.bind(this));
        this.iframes = new window.Payone.ClientApi.HostedIFrames(config, request);
        if (request.mode === 'test') {
            // Erst nach Timeout setzen: wird sonst von Payone-Initialisierung überschreiben
            setTimeout(() => {
                this.errorMessageTarget.textContent = 'TESTMODE';
            }, 500);
        }
    }

    check(event) {
        event.preventDefault();
        if (this.iframes.isComplete() && this.ccnameTarget.value) {
            this.errorMessageTarget.textContent = '';
            this.iframes.creditCardCheck(this.callback_name);
        } else {
            this.onError(translate('tpWeb.frontend.global.errorMessage.pleaseCheckYourData', 'Please verify your inputs.'));
        }
    }

    checkCallback(response) {
        if (response.status === "VALID") {
            this.ccnoTarget.value = response.pseudocardpan;
            this.ccnoteaserTarget.value = response.truncatedcardpan;
            this.ccyyyyTarget.value = "20" + response.cardexpiredate.substr(0, 2);
            this.ccmmTarget.value = response.cardexpiredate.substr(2, 2);
            this.cccompanyTarget.value = this.constructor.cardtypes[response.cardtype];
            setTimeout(() => this.form.submit(), 1);
        } else {
            this.ccnoTarget.value = "";
            this.ccnoteaserTarget.value = "";
            this.ccyyyyTarget.value = "";
            this.ccmmTarget.value = "";
            this.cccompanyTarget.value = "";
            this.onError(translate('tpWeb.frontend.global.payOne.error.' + response.errorcode, response.errormessage));
        }
    }

    onError(message) {
        this.submitButton.innerHTML = this.submit_button_text;
        this.submitButton.disabled = false;
        this.errorMessageTarget.textContent = message;
    }

    get config() {
        var cardtypeOptions = Object.keys(this.constructor.cardtypes);
        cardtypeOptions.unshift('#'); // bitte wählen
        return {
            fields: {
                cardtype: {
                    cardtypes: cardtypeOptions,
                    selector: this.cardtypeTarget.id
                },
                cardpan: {
                    selector: this.cardpanTarget.id
                },
                cardcvc2: {
                    selector: this.cardcvc2Target.id,
                    type: "password",
                    size: "4",
                    maxlength: "4"
                },
                cardexpiremonth: {
                    selector: this.cardexpiremonthTarget.id,
                    size: "2",
                    maxlength: "2"
                },
                cardexpireyear: {
                    selector: this.cardexpireyearTarget.id
                }
            },
            defaultStyle: {
                input: this.data.get("input-style"),
                select: this.data.get("select-style"),
                iframe: {
                    height: this.data.get("iframe-height"),
                    width: this.data.get("iframe-width")
                }
            },
            error: this.errorMessageTarget.id,
            language: Payone.ClientApi.Language[translate.language()] || Payone.ClientApi.Language.en,
            autoCardtypeDetection: {
                supportedCardtypes: Object.keys(this.constructor.cardtypes)
            }
        }
    }
}
